//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            startValue: null,
            endValue: null
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    const [start, end] = newVal.split('-');
                    this.startValue = start ? this.$moment(start, 'HH:mm') : null;
                    this.endValue = end ? this.$moment(end, 'HH:mm') : null;
                } else {
                    this.startValue = null;
                    this.endValue = null;
                }
            }
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        startPlaceholder: {
            type: String,
            default: '開始時間'
        },
        endPlaceholder: {
            type: String,
            default: '結束時間'
        },
        disabled: Boolean
    },
    methods: {
        handleStartChange(time) {
            this.startValue = time;
            this.emitTimeRange();
        },
        handleEndChange(time) {
            this.endValue = time;
            this.emitTimeRange();
        },
        emitTimeRange() {
            const format = 'HH:mm';
            const startStr = this.startValue ? this.startValue.format(format) : '';
            const endStr = this.endValue ? this.endValue.format(format) : '';

            const value = (startStr && endStr) ? `${startStr}-${endStr}` : '';

            this.$emit('change', value);
        },
        handleBlur() {
            this.$emit('blur');
        }
    }
}
